// export const API_URL_MAIN = "https://idless-micro-arch.azurewebsites.net/api";
// export const API_URL_SECONDARY = "https://idless-micro-arch-1.azurewebsites.net/api";

import { CONFIG } from "../config";

interface ApiOptions {
  method?: string;
  body?: any;
  token?: string | null;
  retries?: number;
  delayMs?: number;
  baseUrl?: string;
  // Optional per-call timeout; omit to keep the previous (unbounded) behavior for existing callers.
  timeoutMs?: number;
}

export async function apiCall<T>(
  route: string,
  {
    method = "POST",
    body,
    token,
    retries = 0,
    delayMs = 300,
    baseUrl = CONFIG.apiUrlMain,
    timeoutMs,
  }: ApiOptions = {},
): Promise<T> {
  const doFetch = async (attempt: number): Promise<T> => {
    const controller = timeoutMs ? new AbortController() : undefined;
    const timeoutId = controller
      ? setTimeout(() => controller.abort(), timeoutMs)
      : undefined;

    try {
      const res = await fetch(`${baseUrl}/${route}`, {
        method,
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        body: body ? JSON.stringify(body) : undefined,
        signal: controller?.signal,
      });

      if (!res.ok) {
        let errorMessage = `HTTP ${res.status}`;

        try {
          const data = await res.json();
          if (data?.error) {
            errorMessage = data.error;
          }
        } catch {
          throw new Error(`HTTP ${res.status}`);
        }

        throw new Error(errorMessage);
      }

      // Await here so the timeout also covers reading the body.
      return await res.json();
    } catch (err) {
      if (attempt < retries) {
        await new Promise((r) => setTimeout(r, delayMs));
        return doFetch(attempt + 1);
      }
      throw err;
    } finally {
      if (timeoutId) clearTimeout(timeoutId);
    }
  };

  return doFetch(0);
}
